// if there is no valid thumbnail url, show message stating as such
import * as React from 'react';

// copied from card.jsx
const handleThumbnailError = ({ event, resource }) => {
  // Hacky, but don't want to implement state unless necessary
  const { extension, name } = resource.attributes;
  const modifiedExtension = extension ? extension.replace('.', '') : '-';
  const source = (modifiedExtension) ? `//static-fast.brandfolder.com/assets/types/${modifiedExtension}.svg` : `//static-fast.brandfolder.com/assets/types/file.svg`;
  event.target.src = source;
  event.target.alt = name;
  event.target.style.cssText = "padding: 25px;";
}

const AssetBoardCardThumbnail = ({ children, resource, setShowOverlay }) => {
  return (
    <div
      className="thumbnail-container"
      onMouseEnter={() => setShowOverlay(true)}
      onMouseLeave={() => setShowOverlay(false)}
    >
      {children}
      {
        resource.attributes.thumbnail_url ?
        (
          <div className="thumbnail">
            <img src={resource.attributes.thumbnail_url }
              onError={event => {
                handleThumbnailError({event, resource});
              }}
            />
          </div>
        ) :
        (
          <div className="no-thumbnail">
            <span>{t("This board has no assets.")}</span>
          </div>
        )
      }
    </div>
  );
};

export default AssetBoardCardThumbnail;
